function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M27 12.3613C27 15.1384 25.683 17.8018 23.3388 19.7655C20.9946 21.7292 17.8152 22.8325 14.5 22.8325C12.8585 22.8325 11.233 22.5616 9.71646 22.0354C8.19989 21.5092 6.8219 20.7379 5.66117 19.7655C4.50043 18.7932 3.57969 17.6388 2.9515 16.3684C2.32332 15.098 2 13.7364 2 12.3613C2 9.58411 3.31696 6.92072 5.66117 4.95699C8.00537 2.99326 11.1848 1.89005 14.5 1.89005C17.8152 1.89005 20.9946 2.99326 23.3388 4.95699C25.683 6.92073 27 9.58412 27 12.3613Z",
  stroke: "#EFEFEF",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.66113 19.7655L23.3388 4.957",
  stroke: "#EFEFEF",
  strokeWidth: 3
});

var SvgCancelIcon = function SvgCancelIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCancelIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cancel-icon.c80404aa.svg";
export { ForwardRef as ReactComponent };